import { render } from "./loginModal.vue?vue&type=template&id=4167275a&scoped=true"
import script from "./loginModal.vue?vue&type=script&lang=js"
export * from "./loginModal.vue?vue&type=script&lang=js"

import "./loginModal.vue?vue&type=style&index=0&id=4167275a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4167275a"]])

export default __exports__